import type { NavLink } from "@/components/ui/navbar";
import { BaseApiClient } from "../api/baseApiClient.service";

export class NavigationService {
	static path = "navigation";

	/**
	 * Get the navigation links for the user
	 * @returns The navigation links for the user
	 */
	static async getNavLinks(): Promise<NavLink[]> {
		// Fetch with cache-busting param to avoid stale caches
		const data = await BaseApiClient.getInstance().get<unknown>(
			`${NavigationService.path}/links`,
			{ _t: Date.now() },
		);

		// Normalize various possible backend shapes into NavLink[]
		const isValidLink = (v: unknown): v is NavLink => {
			return (
				typeof v === "object" &&
				v !== null &&
				typeof (v as Record<string, unknown>).label === "string" &&
				typeof (v as Record<string, unknown>).href === "string"
			);
		};

		// Direct array
		if (Array.isArray(data)) {
			return data.filter(isValidLink);
		}

		// Common wrapped shapes: { links: [...] } | { data: [...] } | { items: [...] }
		if (data && typeof data === "object") {
			const maybe =
				(data as Record<string, unknown>).links ??
				(data as Record<string, unknown>).data ??
				(data as Record<string, unknown>).items;
			if (Array.isArray(maybe)) {
				return maybe.filter(isValidLink);
			}
		}

		// Fallback to empty array if shape is unexpected
		return [];
	}
}
